module.exports = __webpack_public_path__ + "img/retrospect-63.c75971c3.jpg";